import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import MuiIconButton from '@material-ui/core/IconButton';
import MuiDoneIcon from '@material-ui/icons/Done';
import MuiSaveIcon from '@material-ui/icons/Save';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import MuiErrorIcon from '@material-ui/icons/Error';
import MuiBlockIcon from '@material-ui/icons/Block';
import MuiEditIcon from '@material-ui/icons/Edit';
import { WithTooltip } from 'utils/wrappers';
import { ERRORS } from 'utils/constants';

const styles = () => ({
  errorButton: {
    cursor: 'default',
  },
});

const RowButtons = props => {
  const { classes, isEditing, setPlatformFeeEditId, isSuccess, isLoading, isError, resetSubmitState } = props;

  const ActionSave = (
    <WithTooltip tooltip="Save Changes">
      <MuiIconButton className={classes.buttonSave} type="submit">
        <MuiSaveIcon />
      </MuiIconButton>
    </WithTooltip>
  );

  const ActionErrorSave = (
    <WithTooltip tooltip={ERRORS.GENERAL.TRY_AGAIN}>
      <MuiIconButton className={classes.errorButton}>
        <MuiErrorIcon />
      </MuiIconButton>
    </WithTooltip>
  );

  const ActionInProgress = (
    <MuiIconButton disabled={true}>
      <MuiCircularProgress size={'1rem'} />
    </MuiIconButton>
  );

  const ActionSuccess = (
    <WithTooltip tooltip="Click to edit again">
      <MuiIconButton className={classes.buttonDone} onClick={resetSubmitState}>
        <MuiDoneIcon />
      </MuiIconButton>
    </WithTooltip>
  );

  const ActionCancel = (
    <WithTooltip tooltip="Cancel">
      <MuiIconButton onClick={() => setPlatformFeeEditId(null)}>
        <MuiBlockIcon />
      </MuiIconButton>
    </WithTooltip>
  );

  if (isSuccess) return ActionSuccess;

  if (!isEditing) {
    return (
      <WithTooltip tooltip="Edit Platform Fees" key="edit">
        <MuiIconButton onClick={resetSubmitState}>
          <MuiEditIcon />
        </MuiIconButton>
      </WithTooltip>
    );
  }

  return (
    <>
      {isLoading && ActionInProgress}
      {isError && ActionErrorSave}
      {ActionCancel}
      {ActionSave}
    </>
  );
};

RowButtons.defaultProps = {
  setPlatformFeeEditId: () => {},
  resetSubmitState: () => {},
};

export default withStyles(styles)(RowButtons);
